import Link from 'next/link';
import { useRouter } from 'next/router';
import { Nav } from 'react-bootstrap';

export default function AdminNav() {
  const router = useRouter();

  return (
    <Nav variant="tabs" className="mt-3" defaultActiveKey={router.asPath}>
      <Nav.Item key="/admin">
        <Link passHref href="/admin" legacyBehavior>
          <Nav.Link>Find Users/Hosts</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link passHref href="/admin/bookings" legacyBehavior>
          <Nav.Link>Bookings</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link passHref href="/admin/reviews" legacyBehavior>
          <Nav.Link>Reviews</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link passHref href="/admin/waitlist" legacyBehavior>
          <Nav.Link>Waitlist</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link passHref href="/admin/reporting" legacyBehavior>
          <Nav.Link>Reporting</Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  );
}
